import startRegl from "lib/regl";
/**
 * Apply a nice error to the DOM when a regl error occurs.
 */
export function initRegl(config = {}) {
    const baseConfig = {
        onDone: (...args) => {
            if (typeof config.onDone === "function") {
                config.onDone(...args);
            }
            const [err] = args;
            if (err) {
                const div = document.createElement("div");
                document.body.appendChild(div);
                div.className = "error";
                const divInner = document.createElement("div");
                divInner.innerText = String(err);
                div.appendChild(divInner);
            }
        },
    };
    const combinedConfig = {
        ...baseConfig,
        ...config,
    };
    const { canvas } = combinedConfig;
    if (canvas) {
        delete combinedConfig.canvas;
        return startRegl(canvas, combinedConfig);
    }
    return startRegl(combinedConfig);
}
/**
 * A utility to apply the TypeScript types to the regl command in a minimalist way.
 */
export function drawCommand(regl, drawConfig) {
    return regl(drawConfig);
}
export function accessors() {
    function getProp(key, defaultValue) {
        return (_, props) => {
            if (!props && defaultValue !== undefined) {
                return defaultValue;
            }
            const value = props[key];
            if (value === undefined && defaultValue !== undefined) {
                return defaultValue;
            }
            return value;
        };
    }
    function getContext(key, defaultValue) {
        return (ctx, _) => {
            const value = ctx[key];
            if (value === undefined && defaultValue !== undefined) {
                return defaultValue;
            }
            return value;
        };
    }
    return { getProp, getContext };
}
/**
 * Work around CommandBodyFn types not seeming to work as I expect them to.
 */
export function composeDrawCommands(drawA, drawB) {
    const name = `composed(${drawA.name},${drawB.name})`;
    const namedFn = {
        [name]: (props) => {
            drawA(props, () => drawB(props));
        },
    };
    return namedFn[name];
}
/**
 * Memoizes a function based on the current draw tick.
 */
export function tickMemoized(fn) {
    let lastTick = -1;
    let lastT;
    return (ctx) => {
        if (ctx.tick !== lastTick) {
            lastT = fn(ctx);
            lastTick = ctx.tick;
        }
        return lastT;
    };
}
/**
 * Allow for tagging content using a template literal. This function passes through
 * the template literal.
 */
function passThroughTemplateLiteral(strings, ...injections) {
    let output = "";
    const length = Math.max(strings.length, injections.length);
    for (let i = 0; i < length; i++) {
        const string = strings[i];
        const injection = injections[i];
        if (i < strings.length) {
            output += string;
        }
        if (i < injections.length) {
            output += injection;
        }
    }
    return output;
}
export const glsl = passThroughTemplateLiteral;
